import { wrapCreateBrowserRouter } from "@sentry/react"
import { createBrowserRouter, Navigate } from "react-router-dom"

const sentryCreateBrowserRouter = wrapCreateBrowserRouter(createBrowserRouter)
import OAuthCallbackPage from "@/pages/OAuthCallbackPage"
import Mentoring from "@/modules/Mentorings/pages/MentoringsPage"
import Palestras from "@/modules/Lectures/pages/LecturesPage"
import Network from "@/modules/Networking/pages/NetworkingPage"
import Profile from "@/modules/Auth/pages/ProfilePage"
import Progresso from "@/modules/Progress/pages/ProgressPage"
import AvaliacaoMentoria from "@/modules/Mentorings/pages/MentoringsRatingPage"
import { CreateMemberPage } from "@/modules/Users/pages/CreateMemberPage"
import { EditMemberPage } from "@/modules/Users/pages/EditMemberPage"
import BackofficeLogin from "@/modules/Auth/pages/LoginPage"
import BackofficeDashboard from "@/modules/Dashboard/pages/DashboardPage"
import BackofficeUsers from "@/modules/Users/pages/UsersPage"
import BackofficeEvents from "@/modules/Events/pages/EventsPage"
import EventDetailPage from "@/modules/Events/pages/EventDetailPage"
import EventSubscriptionDetailPage from "@/modules/Events/pages/EventSubscriptionDetailPage"
import BackofficeResetPassword from "@/modules/Auth/pages/ResetPasswordPage"
// import BackofficeEventSubscription from "@/modules/Events/pages/EventsSubscriptionsPage"
import BackofficeLogs from "@/modules/Settings/pages/LogsPage"
// import EventsSubscriptions from "@/modules/Events/pages/EventsSubscriptionsPage"
import NotFound from "@/modules/Auth/pages/NotFoundPage"
import EventsMySubscriptionsPage from "@/modules/Events/pages/EventsMySubscriptionsPage"
import { EventsSubscriptionsPage } from "@/modules/Events/pages/EventsSubscriptionsPage"
import { BackofficeLayout } from "@/components/Templates/BackofficeLayout"
import { PrivateRoute } from "@/routes/ProtectedRoute"
import { GestaoAppRoute } from "@/routes/GestaoAppRoute"
import { EventsMemberSubscriptionsPage } from "@/modules/Events/pages/EventsMemberSubscriptionsPage"
import { MemberProfilePage } from "@/modules/Networking/pages/MemberProfilePage"
// Plano de Ação oculto do backoffice — rotas comentadas junto com as importações abaixo.
// import ActionPlansPage from "@/modules/ActionPlans/pages/ActionPlansPage"
// import ActionPlansItemPage from "@/modules/ActionPlans/pages/ActionPlansItemPage"
import ReprisesPage from "@/modules/Reprises/pages/ReprisesPage"
// import ActionPlansCompanyPage from "@/modules/ActionPlans/pages/ActionPlansCompanyPage"
import CompanyProfilePage from "@/modules/CompanyProfile/pages/CompanyProfilePage"
import { OverdeliveryPage } from "@/modules/Overdelivery/pages/OverdeliveryPage"
import FaceCapturePage from "@/modules/Users/pages/FaceCapturePage"
import PersonificationPage from "@/modules/Personification/pages/PersonificationPage"

export const router = sentryCreateBrowserRouter([
  //********************
  // ROTAS PÚBLICAS
  //********************
  {
    path: "/",
    element: (
      <Navigate
        to="/login"
        replace
      />
    ),
  },
  {
    path: "/login",
    element: <BackofficeLogin />,
  },
  {
    path: "/reset-password",
    element: <BackofficeResetPassword />,
  },
  {
    path: "/oauth/callback",
    element: <OAuthCallbackPage />,
  },

  //********************
  // ROTAS PRIVADAS
  //********************
  {
    element: (
      <PrivateRoute>
        <BackofficeLayout />
      </PrivateRoute>
    ),
    children: [
      { path: "dashboard", element: <BackofficeDashboard /> },
      { path: "users", element: <BackofficeUsers /> },
      { path: "users/create", element: <CreateMemberPage /> },
      { path: "users/edit/:id", element: <EditMemberPage /> },
      { path: "events", element: <BackofficeEvents /> },
      { path: "events/:id", element: <EventDetailPage /> },
      { path: "my-subscriptions", element: <EventsMySubscriptionsPage /> },
      { path: "subscriptions", element: <EventsSubscriptionsPage /> },
      { path: "subscriptions/event/:id", element: <EventSubscriptionDetailPage /> },
      { path: "logs", element: <BackofficeLogs /> },
      { path: "profile", element: <Profile /> },
      { path: "company-profile", element: <CompanyProfilePage /> },
      { path: "network", element: <Network /> },
      { path: "network/member/:id", element: <MemberProfilePage /> },
      { path: "lectures", element: <Palestras /> },
      { path: "mentoring", element: <Mentoring /> },
      // { path: "mentoring/action-plans", element: <ActionPlansPage /> },
      // { path: "mentoring/action-plans/:id", element: <ActionPlansItemPage /> },
      { path: "rating-mentoring", element: <AvaliacaoMentoria /> },
      { path: "progresso", element: <Progresso /> },
      { path: "reprises", element: <ReprisesPage /> },
      // { path: "company-action-plans", element: <ActionPlansCompanyPage /> },
      { path: "overdelivery", element: <OverdeliveryPage /> },
      { path: "face-capture", element: <FaceCapturePage /> },
      {
        path: "personificacao",
        element: (
          <GestaoAppRoute>
            <PersonificationPage />
          </GestaoAppRoute>
        ),
      },
      // {
      //   path: "subscriptions/:origin/:id/subscription/:eventName",
      //   element: <BackofficeEventSubscription />,
      // },
      {
        path: "subscriptions/member/:id/:name",
        element: <EventsMemberSubscriptionsPage />,
      },
      // {
      //   path: "events/:id/subscriptions",
      //   element: <BackofficeEventSubscription />,
      // },
    ],
  },

  //********************
  // ROTA 404
  //********************
  {
    path: "*",
    element: <NotFound />,
  },
])
